module.exports = __webpack_public_path__ + "images/emoji/cat.8680e2a16af66a9f401b.png";